import { render, staticRenderFns } from "./personalsidebar.vue?vue&type=template&id=6ee6101a&scoped=true&"
import script from "./personalsidebar.vue?vue&type=script&lang=js&"
export * from "./personalsidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee6101a",
  null
  
)

export default component.exports